import { css } from "lit";

export const switchStyles = css`
  .switch-container {
    display: grid;
    grid-template-areas:
      "label switch"
      "description .";
    grid-template-columns: 1fr auto;
    column-gap: var(--sds-size-space-300);

    width: 100%;
    padding: 24px 0;
    border-top: 1px solid var(--sds-color-border-default-default);
  }

  .label {
    grid-area: label;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    align-self: center;
  }

  .switch-wrapper {
    grid-area: switch;
    display: flex;
    align-items: center;
  }

  .description {
    grid-area: description;
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .error-message {
    grid-area: description;
    color: var(--sds-color-text-danger-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
  }

  .fake-switch {
    box-sizing: border-box;
    display: flex;
    width: 40px;
    height: 24px;
    padding: var(--sds-size-space-150);
    justify-content: flex-end;
    align-items: center;
    border-radius: 4px;
    background: var(--sds-color-background-default-secondary);
    position: relative;
    transition: background-color 0.3s ease;
    cursor: pointer;

    input {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
      margin: 0;
      z-index: 1;
    }

    &::before {
      content: "";
      width: 16px;
      height: 16px;
      border-radius: 2px;
      background: var(--sds-color-background-neutral-default);
      position: absolute;
      left: 4px;
      transition: all 0.3s ease;
    }

    &:has(input:checked) {
      background: var(--sds-color-background-positive-default);

      &::before {
        background: var(--sds-color-background-default-default);
        left: 20px;
      }
    }

    &:has(input:disabled) {
      opacity: 0.6;
      cursor: not-allowed;

      input {
        cursor: not-allowed;
      }
    }
  }

  /* Disabled state for text elements */
  :host([disabled]) .label {
    color: var(--sds-color-text-disabled-default);
  }

  :host([disabled]) .description {
    color: var(--sds-color-text-disabled-default);
  }

  /* Focus states */
  .fake-switch:has(input:focus-visible) {
    outline: 2px solid var(--sds-color-border-brand-default);
    outline-offset: 2px;
  }
`;
